/* eslint-disable default-case */
import React, { useState } from 'react'
import { Button, Menu, Modal } from 'antd'
import { nanoid } from 'nanoid'
import { useAuth0 } from '@auth0/auth0-react'

import TournamentProperties from './display/TournamentProperties'
import TournamentList from './display/TournamentList'
import { LogoutOutlined, QuestionCircleFilled } from '@ant-design/icons'
import { getTournaments } from '../../shared/restClient'
import metadata from '../../metadata.json'

import './css/page-menu.css'

const { SubMenu } = Menu
const { info } = Modal
const userAgent = navigator.userAgent.toLowerCase()

const ManagerMenu = (props) => {
  const { logout } = useAuth0()
  const [isNewTournamentModalVisible, setNewTournamentModalVisible] = useState(false)
  const [availableTournaments, setAvailableTournaments] = useState([])
  const [isTournamentListModalVisible, setTournamentListModalVisible] = useState(false)

  const handleClick = (e) => {
    switch (e.key) {
      case 'new': {
        setNewTournamentModalVisible(true)
        break
      }
      case 'open': {
        async function listTournaments () {
          const data = await getTournaments()
          setAvailableTournaments(data)
          setTournamentListModalVisible(true)
        }
        listTournaments()
        break
      }
      case 'help': {
        info({
          title: 'About Tournament Manager',
          content: (
            <div>
              Current Version: {`${metadata.buildMajor}.${metadata.buildMinor}.${metadata.buildRevision} ${metadata.buildTag}`}
            </div>
          )
        })
        break
      }
      case 'logout': {
        logout({ returnTo: window.location.origin })
        break
      }
      case 'quit': {
        if (userAgent.indexOf(' electron/') > -1) {
          // ipc.quitApp()
        } else {
          logout({ returnTo: window.location.origin })
        }
        break
      }
    }
  }

  const handleCreate = (tournament) => {
    handleCancel()
    if (!tournament.uuid) {
      tournament.uuid = nanoid()
    }
    props.addTournament(prevState => [...prevState, tournament])
  }

  const handleCancel = () => {
    setNewTournamentModalVisible(false)
    setTournamentListModalVisible(false)
  }

  const handleLoad = (tournament) => {
    handleCancel()
    props.addTournament(prevState => [...prevState, tournament])
  }

  return (
    <>
      <Menu className='page-menu' onClick={handleClick} mode='horizontal' selectable={false} triggerSubMenuAction='click' theme='dark'>
        <SubMenu key='file_menu' title='File'>
          <Menu.Item key='new'>New</Menu.Item>
          <Menu.Item key='open'>Open</Menu.Item>
          <Menu.Item key='import' disabled>Import</Menu.Item>
          <Menu.Divider />
          <Menu.Item key='quit'>Quit</Menu.Item>
        </SubMenu>
        <Menu.Item key='logout' style={{ position: 'absolute', right: 100 }}>
          <Button type='primary' shape='round' icon={<LogoutOutlined />}>
            Logout
          </Button>
        </Menu.Item>
        <Menu.Item key='help' style={{ position: 'absolute', right: 0 }}>
          <Button type='primary' shape='round' icon={<QuestionCircleFilled />}>
            Help
          </Button>
        </Menu.Item>
      </Menu>
      <Modal title='New Tournament' width={640} visible={isNewTournamentModalVisible} maskClosable={false} destroyOnClose onCancel={handleCancel} footer={null}>
        <TournamentProperties handleCancel={handleCancel} handleOk={handleCreate} />
      </Modal>
      <Modal title='Available Tournaments' width={640} visible={isTournamentListModalVisible} maskClosable={false} destroyOnClose onCancel={handleCancel} footer={null}>
        <TournamentList tournaments={availableTournaments} onSelect={handleLoad} handleCancel={handleCancel} />
      </Modal>
    </>
  )
}

export default ManagerMenu
